<mbsc-popup [options]="horizontalSettings" #horizontalPopup="mobiscroll" class="alertCustomPopop1">
    <ng-content></ng-content>
</mbsc-popup>